import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/rem';

  .InvestEditRatioForm__caption {
    color: #777777;
    font-size: rem(12px);
    margin: rem(0 0 25px);
  }
`;

export { staticStyles };
